import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgX = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path fill="currentColor" d="M15.73 17.256h1.626L9.872 6.78H8.246z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.472 2c-.92 0-1.666.746-1.666 1.667v16.666c0 .92.746 1.667 1.666 1.667H21.14c.92 0 1.666-.746 1.666-1.667V3.667c0-.92-.746-1.667-1.666-1.667zm13.942 4-4.467 5.081L18.805 18h-3.573l-3.271-4.66L7.863 18H6.806l4.685-5.328L6.806 6h3.573l3.098 4.412L17.356 6z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgX;
